import { render } from "./Description.vue?vue&type=template&id=341ae508&scoped=true&ts=true"
import script from "./Description.vue?vue&type=script&lang=ts"
export * from "./Description.vue?vue&type=script&lang=ts"

import "./Description.vue?vue&type=style&index=0&id=341ae508&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341ae508"]])

export default __exports__